// extracted by mini-css-extract-plugin
export default {"blockMenu":"style_blockMenu__QBxgg","blockTitle":"style_blockTitle__gOOPK","menu":"style_menu__m5pwH"};